import React from 'react';
import PrivacyPolicy from './PrivacyPolicy.md';
import ReactMarkdown from 'react-markdown'
import {Box} from "@mui/material";
import {Helmet} from "react-helmet";

function Privacy(){
    return (
        <Box margin={"25px"} marginBottom={"75px"}>
            <Helmet>
                <title>PairCare - Privacy Policy</title>
            </Helmet>
            <Box style={{marginLeft:"auto", marginRight:"auto",  maxWidth:"750px"}}>
                <ReactMarkdown>{PrivacyPolicy}</ReactMarkdown>
            </Box>
        </Box>
    );
}

export default Privacy;